export default __webpack_public_path__ + "static/media/warning-yellow.1037c60a.svg";